/**
 * WEB-1692 (ядро карточки) — ОФОРМЛЕНИЕ БЛОКА ПО СМЫСЛОВЫМ РОЛЯМ ТЕКСТА.
 *
 * Репорт владельца 24.08 про «Утверждение»: «сейчас все настройки для текстов
 * для этого блока применяются ко всему тексту. Нужно разбить отдельно
 * заголовок и отдельно подписи под эмодзи». Про «Карточку предпочтения» тогда
 * же: «то же самое нужно разбить настройки текста для заголовка и для
 * содержимого».
 *
 * КОРЕНЬ. У обоих блоков не было НИ ОДНОЙ собственной настройки оформления:
 * компоненты (`StatementAgreementBlock`, `PreferenceCardBlock`) принимали
 * только содержимое, а кегли лежали внутри них числами. Красили блок общие
 * поля «Цвет/Размер текста внутри элемента» (`innerTextColor`/`innerFontSize`),
 * которые через `blockInnerSurface` ложатся на ВСЁ поддерево блока разом —
 * развести главный текст и подписи было физически нечем.
 *
 * ДВЕ РОЛИ, А НЕ ПО ПОЛЮ НА КАЖДЫЙ ТЕКСТ. Настройка заводится на СМЫСЛОВУЮ
 * РОЛЬ текста — ровно как владелец сформулировал у «Двух колонок»: «не по
 * колонкам, а по ролям».
 *  · роль `Title` — главный текст блока: само утверждение / вопрос карточки
 *    (оба лежат в общем поле `content`);
 *  · роль `Secondary` — вторичные тексты под ним.
 *
 * ЧТО ИМЕННО ВОШЛО В РОЛЬ `Secondary` — РЕШЕНО ЯВНО (карточка требует не
 * оставлять это «как получилось»):
 *  · «Утверждение»: строка-вопрос (`statementPrompt`) И три подписи реакций.
 *    Владелец называл только подписи под эмодзи, про строку-вопрос молчал.
 *    Она отнесена к вторичным, потому что сегодня она НЕОТЛИЧИМА от подписей
 *    по оформлению (тот же приглушённый `--color-text-secondary`, кегль 14
 *    против 13) и по смыслу это такая же обслуживающая строка при
 *    утверждении. Третья настройка на неё одну была бы настройкой ради
 *    настройки.
 *  · «Карточка предпочтения»: подпись под картинкой (`preferenceCaption`) и
 *    подписи двух ответов — ОДНОЙ настройкой, как и рекомендовала карточка.
 *    Оба текста — вторичные при вопросе, дробить их незачем.
 *
 * ЧТО В РОЛИ НЕ УЧАСТВУЕТ: эмодзи-глифы реакций (26px), глифы ✕/✓ ответов
 * (24px) и эмодзи-заглушка вместо обложки (64px). Владелец про них не
 * говорил, а размер глифа привязан к диаметру круга и к вёрстке карточки —
 * потянув его кеглем текста, разъехались бы сами кнопки. Понадобится —
 * отдельным полем «размер эмодзи», не этим.
 *
 * ПУСТО = СЕГОДНЯШНИЙ ВИД ДО ПИКСЕЛЯ (⛔ распоряжение владельца 24.08 «живые
 * воронки не трогаем»). Слой автора отдаётся НАКЛАДКОЙ (`{ color }` /
 * `{ fontSize }` либо ПУСТОЙ объект), которую компонент спредит ПОСЛЕ прежних
 * строк: при пустом поле спредится `{}`, и inline-стиль старой воронки не
 * меняется ни на байт. Прежние зашитые числа и переменные темы остаются в
 * исходнике дословно.
 *
 * ⚠ РАЗНИЦА МЕЖДУ ВЫБРАННОЙ И НЕВЫБРАННОЙ ПОДПИСЬЮ — НЕ ТЕРЯЕТСЯ. У
 * «Утверждения» подпись выбранной реакции сегодня тёмная
 * (`--color-text-primary`), остальные приглушены (`--color-text-secondary`):
 * так видно, что выбрано. Одна общая настройка цвета эту разницу убила бы.
 * Решение — вариант «А» (считать автоматически), рекомендованный оркестратором
 * для той же развилки у шкалы ИМТ, полос «Сейчас/Цель» и звёзд оценки:
 * авторский цвет ставится ЦЕЛИКОМ, а невыбранные подписи приглушаются
 * прозрачностью от него же (`MUTED_TEXT_ROLE_OPACITY`). Приглушение
 * появляется ТОЛЬКО вместе с авторским цветом — без него не меняется ничего.
 *
 * Почему приглушаем прозрачностью, а не вычисленным оттенком: авторское
 * значение может быть чем угодно из принятых форм записи цвета (код, имя,
 * `rgb()`, `var(--…)`), и разбирать его, чтобы посчитать оттенок, значит
 * завести второй разборщик цвета в проекте. Прозрачность работает с любой
 * формой записи и ничего не разбирает.
 *
 * У «Карточки предпочтения» приглушения НЕТ намеренно: там подписи ответов
 * состояния выбора цветом не несут вовсе (выбор виден рамкой и заливкой самой
 * карточки-ответа), приглушать нечего.
 *
 * ИМЕНОВАНИЕ — ШАБЛОН ДЛЯ ВСЕЙ БУДУЩЕЙ ПАЧКИ. Имя = префикс блока + роль +
 * свойство: `statementTitleColor`, `statementSecondaryFontSize`,
 * `preferenceTitleColor`, … Образец назначен самой карточкой — пара
 * `countdownDigit*` (имя блока + роль элемента + свойство) и уже сделанный по
 * ней «Микро-фидбек» (`feedbackTitleFontSize`/`feedbackDetailFontSize`,
 * WEB-1430). Суффикс `FontSize`, а не `SizePx`, — потому что так названы все
 * кегли проекта, привязанные к общему диапазону 8..72
 * (`optionFontSize`, `captionChipFontSize`, `inputLabelFontSize`,
 * `payErrorFontSize`); `countdownDigitSizePx` — одиночка со своим диапазоном
 * 16..96, и заводить второй такой не нужно.
 *
 * Список блоков ниже — ЗЕРКАЛО канона бэка
 * (backend/src/ai-funnels/block-schema/semantic-text-roles.ts). Разъезд ловит
 * сторож `semantic-text-roles.web1692.spec.ts` (читает ЭТОТ файл с диска) — не
 * переименовывать и не менять форму объекта, не обновив его.
 */

/**
 * Тип блока → префикс его полей роли. Зеркало канона бэка.
 *
 * ⚠ АННОТАЦИИ `Record<string, string>` ЗДЕСЬ НЕТ НАМЕРЕННО (WEB-1692, ревизия
 * пачки 6): она стирала ЛИТЕРАЛЬНЫЕ ключи, а из них выводится тип «какие роли
 * есть у этого типа блока» — им проверяется на сборке, что панель дала подписи
 * КАЖДОЙ роли, которая у блока есть. Без литералов проверка невозможна, и роль
 * молча пропадала бы из панели при живых полях в схеме и рендере (ловушка
 * WEB-1496 п.4). Ключ-строку читать через `semanticTextRolePrefix`.
 *
 * Форма записи (объектный литерал сразу после имени, значения одинарными
 * кавычками) — под сторожем semantic-text-roles.web1692.spec.ts: он читает
 * ЭТОТ файл с диска регуляркой, отсчитывая скобки литерала. Менять форму, не
 * обновив сторож, нельзя — и по той же причине в комментариях рядом не должно
 * быть скобок, похожих на границы литерала.
 */
export const SEMANTIC_TEXT_ROLE_PREFIXES = {
  accordion: 'accordion',
  before_after: 'beforeAfter',
  blur_teaser: 'blurTeaser',
  bmi_scale: 'bmi',
  card: 'card',
  chart: 'chart',
  columns_2: 'column',
  cookie_consent: 'cookie',
  countdown: 'countdown',
  downsell_offer: 'downsellOffer',
  downsell_popup: 'downsell',
  hero: 'hero',
  likert_scale: 'likert',
  loader_processing: 'loader',
  now_goal_bars: 'nowGoal',
  plan_selector: 'plan',
  preference_card: 'preference',
  promo_ticket: 'promoTicket',
  rating_chip: 'chip',
  review_stars: 'review',
  slider_range: 'slider',
  statement_agreement: 'statement',
  subscription_list: 'subscriptionList',
  testimonials: 'testimonial',
  timer: 'timer',
};

/** Роли текста. Их ДВЕ на весь механизм — третью заводить не молча. */
export const SEMANTIC_TEXT_ROLES = ['Title', 'Secondary'] as const;
export type SemanticTextRole = (typeof SEMANTIC_TEXT_ROLES)[number];

/**
 * ЮНИТ «ЗАШИТЫЕ ПИКСЕЛИ» (WEB-1692) — БЛОКИ, У КОТОРЫХ РОЛИ НЕ ДВЕ, А ОДНА.
 *
 * У «До и после» на экране один настраиваемый текст — подписи «до» и «после»
 * (обе одной настройкой: это однородная пара, та же группировка по роли, что
 * владелец назвал у двух колонок). Второй текст блока — серая заглушка на
 * месте незагруженной картинки, и карточка выводит её из-под настройки прямо:
 * это служебный вид редактора, а не оформление воронки (то же решение, что по
 * пунктирным рамкам-заглушкам в WEB-1697).
 *
 * Значит роли `Secondary` у блока НЕТ ЧЕГО КРАСИТЬ. Завести её «для
 * единообразия» означало бы мёртвую настройку — ловушка WEB-1496 п.4, ровно
 * та, из-за которой WEB-1677 заводил списки применимости общим полям.
 * Поэтому отсутствие роли НАЗВАНО здесь, а не оставлено на «как получилось»:
 * имена полей выводятся из шаблона за вычетом этого списка, и «забыть» роль
 * молча нельзя — сторож (`semantic-text-roles.web1692.spec.ts`) сверяет
 * ОБА конца, канон бэка и это зеркало, множествами в обе стороны.
 */
export const SEMANTIC_TEXT_ROLE_OMITTED_ROLES = {
  // `as const` стоит на САМОМ СПИСКЕ, а не на объекте: тип изъятой роли нужен
  // литеральным (из него вычитается набор ролей блока на сборке), а обёртка
  // объекта обязана остаться прежней — открывающую и закрывающую скобки этого
  // литерала ищет с диска сторож зеркала semantic-text-roles.web1692.spec.ts.
  before_after: ['Secondary'] as const,
  // ЮНИТ 2. У «Обратного отсчёта» изъята ДРУГАЯ роль, и причина своя: главный
  // текст блока — цифры, а они настраиваются старшими полями
  // countdownDigitColor / countdownDigitSizePx / countdownDigitFontId
  // (WEB-696) — той самой парой, которую карточка назначила образцом
  // именования. Вторая настройка на то же свойство была бы дублем с
  // необъявленным старшинством. Роль Secondary при этом живая: подписи под
  // цифрами, у них кегль лежал числом 12.
  countdown: ['Title'] as const,
  // ЮНИТ 3. У пейволльного «Таймера» изъятие ТО ЖЕ и по той же причине: цифры
  // — главный текст блока, и они получают свои старшие поля timerDigitColor /
  // timerDigitSizePx / timerDigitFontId, дословную копию набора близнеца
  // «Обратный отсчёт» (WEB-696). Роль Secondary живая: подписи под цифрами.
  timer: ['Title'] as const,
};

/** Тип блока, у которого роли текста ЕСТЬ. Выводится из реестра. */
export type SemanticTextRoleBlockType =
  keyof typeof SEMANTIC_TEXT_ROLE_PREFIXES;

type OmittedRoleRegistry = typeof SEMANTIC_TEXT_ROLE_OMITTED_ROLES;

/**
 * Роли, которые у типа ЕСТЬ, — НА СБОРКЕ. Зеркало рантайм-функции
 * `semanticTextRolesOf` в системе типов: обе вычитают из общего набора ролей
 * те, что названы изъятыми, и обе берут это из одного реестра.
 */
export type SemanticTextRoleOf<T extends SemanticTextRoleBlockType> =
  T extends keyof OmittedRoleRegistry
    ? Exclude<SemanticTextRole, OmittedRoleRegistry[T][number]>
    : SemanticTextRole;

/**
 * Префикс полей типа по СТРОКОВОМУ ключу (тип блока в рендере — строка).
 * Отдельная функция, потому что у реестра теперь литеральные ключи и обращение
 * произвольной строкой типизировать иначе нельзя.
 */
export function semanticTextRolePrefix(blockType: string): string | undefined {
  const registry: Readonly<Record<string, string | undefined>> =
    SEMANTIC_TEXT_ROLE_PREFIXES;
  return registry[blockType];
}

/** Роли, которые у типа ЕСТЬ. */
export function semanticTextRolesOf(
  blockType: string,
): readonly SemanticTextRole[] {
  const registry: Readonly<
    Record<string, readonly SemanticTextRole[] | undefined>
  > = SEMANTIC_TEXT_ROLE_OMITTED_ROLES;
  const omitted = registry[blockType] ?? [];
  return SEMANTIC_TEXT_ROLES.filter((role) => !omitted.includes(role));
}

/** Все имена полей ролей — выводятся из шаблона, а не набираются руками. */
export const SEMANTIC_TEXT_ROLE_FIELD_NAMES: readonly string[] = Object.entries(
  SEMANTIC_TEXT_ROLE_PREFIXES,
).flatMap(([blockType, prefix]) =>
  semanticTextRolesOf(blockType).flatMap((role) => [
    `${prefix}${role}Color`,
    `${prefix}${role}FontSize`,
  ]),
);

/** Накладка на текст роли: цвет и кегль вместе либо ПУСТОЙ объект. */
export interface TextRoleStyle {
  color?: string;
  fontSize?: number;
}

/** Пара накладок блока: главный текст и вторичные тексты под ним. */
export interface BlockTextRoles {
  title: TextRoleStyle;
  secondary: TextRoleStyle;
}

/** Поля ролей. Плоские — таков `EditorBlock`. */
export interface SemanticTextRoleFields {
  statementTitleColor?: string;
  statementTitleFontSize?: number;
  statementSecondaryColor?: string;
  statementSecondaryFontSize?: number;
  preferenceTitleColor?: string;
  preferenceTitleFontSize?: number;
  preferenceSecondaryColor?: string;
  preferenceSecondaryFontSize?: number;
  // ── юнит «зашитые пиксели» (WEB-1692): шесть блоков, чьи кегли лежали
  // числами прямо в ветке рендера PublicBlockRendererExtended.
  /** «Две колонки»: заголовки ОБЕИХ колонок — группировка по роли. */
  columnTitleColor?: string;
  columnTitleFontSize?: number;
  /** «Две колонки»: содержимое ОБЕИХ колонок. */
  columnSecondaryColor?: string;
  columnSecondaryFontSize?: number;
  /** «Карточка»: заголовок (`cardTitle`). */
  cardTitleColor?: string;
  cardTitleFontSize?: number;
  /** «Карточка»: описание (`cardDescription`). */
  cardSecondaryColor?: string;
  cardSecondaryFontSize?: number;
  /** «Отзывы»: имя автора в КАЖДОМ отзыве блока. */
  testimonialTitleColor?: string;
  testimonialTitleFontSize?: number;
  /** «Отзывы»: текст отзыва в каждом отзыве блока. */
  testimonialSecondaryColor?: string;
  testimonialSecondaryFontSize?: number;
  /** «Рейтинг отзывов»: крупная цифра рейтинга. */
  reviewTitleColor?: string;
  reviewTitleFontSize?: number;
  /** «Рейтинг отзывов»: подпись под звёздами. */
  reviewSecondaryColor?: string;
  reviewSecondaryFontSize?: number;
  /** «Чип рейтинга»: сама оценка (за её кеглем идёт звёздочка). */
  chipTitleColor?: string;
  chipTitleFontSize?: number;
  /** «Чип рейтинга»: подпись об аудитории. */
  chipSecondaryColor?: string;
  chipSecondaryFontSize?: number;
  /** «До и после»: подписи «до» и «после» разом. Второй роли у блока нет. */
  beforeAfterTitleColor?: string;
  beforeAfterTitleFontSize?: number;
  // ── юнит 2 «настройки есть, но половина» (WEB-1692).
  /**
   * «Обратный отсчёт»: подписи под цифрами (12px). Роли `Title` у блока нет —
   * цифры настраиваются своими старшими полями `countdownDigit*` (WEB-696).
   */
  countdownSecondaryColor?: string;
  countdownSecondaryFontSize?: number;
  // ── юнит 3 «блок отдал отрисовку своему компоненту без единой настройки»
  // (WEB-1692) плюс пейволльный «Таймер».
  /** «Аккордеон»: заголовок пункта (16px, полужирный). */
  accordionTitleColor?: string;
  accordionTitleFontSize?: number;
  /** «Аккордеон»: раскрывающийся текст под заголовком (15px). */
  accordionSecondaryColor?: string;
  accordionSecondaryFontSize?: number;
  /** «Промо-билет»: заголовок билета (14px, денежный акцент). */
  promoTicketTitleColor?: string;
  promoTicketTitleFontSize?: number;
  /** «Промо-билет»: примечание под кодом (12px). */
  promoTicketSecondaryColor?: string;
  promoTicketSecondaryFontSize?: number;
  /** «Список подписок»: заголовок списка. */
  subscriptionListTitleColor?: string;
  subscriptionListTitleFontSize?: number;
  /** «Список подписок»: содержимое плашки (тариф, статус, дата продления). */
  subscriptionListSecondaryColor?: string;
  subscriptionListSecondaryFontSize?: number;
  /**
   * «Таймер»: подписи под цифрами (12px). Роли `Title` у блока нет — цифры
   * настраиваются своими старшими полями `timerDigit*`.
   */
  timerSecondaryColor?: string;
  timerSecondaryFontSize?: number;
  // ── юнит 4 «относительные размеры» и вариант А (WEB-1692, решение владельца
  // 02.09): шесть блоков, где разница элементов НЕСЁТ СМЫСЛ. Автор задаёт одно
  // значение — приглушённый вариант и пропорции система выводит сама.
  /** «Размытый тизер»: заголовок НАД сеткой плашек (снаружи, 1.125em). */
  blurTeaserTitleColor?: string;
  blurTeaserTitleFontSize?: number;
  /** «Размытый тизер»: тексты ВНУТРИ плашки; кегль задаётся по названию строки. */
  blurTeaserSecondaryColor?: string;
  blurTeaserSecondaryFontSize?: number;
  /** «Полосы Сейчас/Цель»: заголовок блока. */
  nowGoalTitleColor?: string;
  nowGoalTitleFontSize?: number;
  /** «Полосы»: подписи полос; сторона «сейчас» приглушается от этого же цвета. */
  nowGoalSecondaryColor?: string;
  nowGoalSecondaryFontSize?: number;
  /** «Шкала ИМТ»: заголовок блока. */
  bmiTitleColor?: string;
  bmiTitleFontSize?: number;
  /** «Шкала ИМТ»: метки зон; неактивные приглушаются от этого же цвета. */
  bmiSecondaryColor?: string;
  bmiSecondaryFontSize?: number;
  /** «Ползунок»: подпись над ползунком (поле `content`). */
  sliderTitleColor?: string;
  sliderTitleFontSize?: number;
  /** «Ползунок»: числа под ползунком (минимум и максимум). */
  sliderSecondaryColor?: string;
  sliderSecondaryFontSize?: number;
  /** «Выбор тарифа»: главная строка карточки — цена, без цены название. */
  planTitleColor?: string;
  planTitleFontSize?: number;
  /** «Выбор тарифа»: подпись-бейдж («выгодно», «популярный»). */
  planSecondaryColor?: string;
  planSecondaryFontSize?: number;
  // ── юнит 5 «два даунселла» (WEB-1692): «Оффер удержания» портала и
  // «Попап-даунселл» экрана оплаты. Префиксы взяты у уже сложившихся семей
  // полей содержимого: попап пишет `downsellTitle`, оффер — `downsellOfferTitle`.
  /** «Оффер удержания»: заголовок оффера. */
  downsellOfferTitleColor?: string;
  downsellOfferTitleFontSize?: number;
  /** «Оффер»: наполнение — текст, строка новой цены, текст после принятия. */
  downsellOfferSecondaryColor?: string;
  downsellOfferSecondaryFontSize?: number;
  /** «Попап-даунселл»: заголовок предложения (18px). */
  downsellTitleColor?: string;
  downsellTitleFontSize?: number;
  /** «Попап-даунселл»: текст предложения (14px). */
  downsellSecondaryColor?: string;
  downsellSecondaryFontSize?: number;
  // ── юнит 7 «хвост зонтика» (WEB-1692): из восьми типов, названных разведкой
  // 03.09, роли получает ОДИН — у остальных семи либо текст один и им дано
  // общее поле кегля, либо настраиваемого текста нет вовсе. Разбор и обе
  // развилки записаны в реестре бэка (semantic-text-roles.ts) и в докблоке
  // FONT_SIZE_BLOCK_TYPES панели.
  /** «Баннер cookie»: сам текст согласия (14px). */
  cookieTitleColor?: string;
  cookieTitleFontSize?: number;
  /** «Баннер cookie»: надписи ОБЕИХ кнопок одной настройкой (13px). */
  cookieSecondaryColor?: string;
  cookieSecondaryFontSize?: number;
  // ── юнит 8 «последняя четвёрка» (WEB-1692, сверка 18.09): типы, у которых на
  // экране есть пара «главный текст + вторичные подписи», а своей настройки
  // вида не было ни одной. Разбор каждой границы — в реестре бэка.
  /** «Обложка»: заголовок. Пусто = адаптивная шкала clamp (WEB-889). */
  heroTitleColor?: string;
  heroTitleFontSize?: number;
  /** «Обложка»: подзаголовок (16px). Надпись кнопки сюда не входит. */
  heroSecondaryColor?: string;
  heroSecondaryFontSize?: number;
  /** «Экран загрузки»: заголовок (19px). */
  loaderTitleColor?: string;
  loaderTitleFontSize?: number;
  /** «Экран загрузки»: подписи стадий, карточки ответов и соцпруф разом. */
  loaderSecondaryColor?: string;
  loaderSecondaryFontSize?: number;
  /** «График»: заголовок (17px, 13px в превью). */
  chartTitleColor?: string;
  chartTitleFontSize?: number;
  /** «График»: подписи шкалы и число начала; число конца остаётся акцентным. */
  chartSecondaryColor?: string;
  chartSecondaryFontSize?: number;
  /** «Шкала Лайкерта»: утверждение (`content`). */
  likertTitleColor?: string;
  likertTitleFontSize?: number;
  /** «Шкала Лайкерта»: подписи делений, цифры и подписи краёв разом. */
  likertSecondaryColor?: string;
  likertSecondaryFontSize?: number;
}

/**
 * СВОИ ПАРЫ ПОЛЕЙ ЮНИТА 4 — элементы, которым роли не подходят.
 *
 * «Шкала ИМТ»: владелец назвал ТРИ группы (заголовок, метки, текст под
 * метками), а ролей две — третьей группе дана своя пара. Число ИМТ с подписью
 * над ним — четвёртая: про них владелец не говорил, но число самый крупный
 * элемент экрана, и оставлять его единственным ненастраиваемым текстом блока
 * значило бы готовить следующий репорт (карточка велит решить явно).
 *
 * «Звёзды оценки»: ролей блок не получает вовсе — его текст правят СТАРШИЕ
 * общие поля («Размер шрифта (px)» и «Цвет текста внутри элемента»), а роль
 * дала бы третье поле на то же свойство. Не настраивались только звёзды — им
 * своя пара по образцу `countdownDigit*`.
 */
export interface Unit4OwnTextFields {
  /** «Шкала ИМТ»: число; подпись над ним считается и приглушается от него. */
  bmiValueColor?: string;
  bmiValueFontSize?: number;
  /** «Шкала ИМТ»: текст под метками зон. */
  bmiNoteColor?: string;
  bmiNoteFontSize?: number;
  /** «Звёзды оценки»: глиф звезды; пустая берёт тот же цвет с прозрачностью. */
  ratingStarColor?: string;
  ratingStarFontSize?: number;
}

/**
 * СВОИ ПАРЫ ПОЛЕЙ ЮНИТА 5 — элементы двух даунселлов, которым роли не подходят.
 *
 * «Оффер удержания»: владелец назвал НАДПИСЬ КНОПКИ третьей настройкой рядом с
 * заголовком и наполнением, а две заливки — отдельно от текста. Общий сборщик
 * кнопок `buttonSurfaceStyle` (WEB-1651-2) здесь не годится: он читает ОБЩИЕ
 * поля блока, а `innerTextColor` у этого типа уже красит весь текст блока —
 * отдав его кнопке, мы и владельцу не дали бы отдельного цвета надписи, и
 * перекрасили бы кнопку в живых воронках, где общий цвет задан.
 *
 * «Попап-даунселл»: ЦЕНА и НАДПИСЬ КНОПКИ — две из четырёх групп, которые
 * карточка перечислила поимённо. Цена крупнее заголовка (22 против 18)
 * НАМЕРЕННО: ради этой скидочной цены попап и показывается.
 */
export interface Unit5OwnTextFields {
  /** «Оффер»: надпись кнопки «принять скидку». Пусто = 14px белым. */
  downsellOfferCtaColor?: string;
  downsellOfferCtaFontSize?: number;
  /** «Оффер»: заливка ВНУТРИ кнопки. Пусто = акцент воронки либо `#1677ff`. */
  downsellOfferCtaBackgroundColor?: string;
  /** «Оффер»: заливка ВНУТРЕННЕЙ ПЛАШКИ. Пусто = без заливки, как сегодня. */
  downsellOfferCardBackgroundColor?: string;
  /** «Попап»: цена со скидкой. Пусто = 22px акцентом. */
  downsellPriceColor?: string;
  downsellPriceFontSize?: number;
  /** «Попап»: надпись кнопки. Пусто = 15px цветом `--color-on-primary`. */
  downsellCtaColor?: string;
  downsellCtaFontSize?: number;
}

/**
 * Доля непрозрачности приглушённой подписи. Число одно на весь механизм:
 * вторая копия разъехалась бы при первой же правке.
 */
export const MUTED_TEXT_ROLE_OPACITY = 0.65;

function trimmed(value?: string): string | undefined {
  return value?.trim() || undefined;
}

/**
 * Код цвета автора либо `undefined`. Экспортируется, потому что ветки
 * отрисовки читают цветовые поля ПОД СОБСТВЕННЫМИ ИМЕНАМИ — этого требует
 * сторож контракта имён (WEB-1500/881, field-name-contract.spec.ts): поле
 * схемы у блока с реестром пар обязано быть прочитано в ветке своего типа,
 * иначе оно молча теряется между генерацией и рендером.
 */
export function trimmedColor(value?: string): string | undefined {
  return trimmed(value);
}

/** Пусто в обоих полях = пустой объект, то есть нулевая правка вида. */
export function textRoleStyle(
  color?: string,
  fontSize?: number,
): TextRoleStyle {
  const style: TextRoleStyle = {};
  const own = trimmed(color);
  if (own) style.color = own;
  if (typeof fontSize === 'number') style.fontSize = fontSize;
  return style;
}

/**
 * Приглушение невыбранной подписи — ТОЛЬКО когда автор задал цвет роли. Без
 * авторского цвета разницу состояний по-прежнему несут переменные темы, и
 * трогать её нельзя (старая воронка).
 */
export function mutedTextRoleStyle(role: TextRoleStyle): { opacity?: number } {
  return role.color ? { opacity: MUTED_TEXT_ROLE_OPACITY } : {};
}

/**
 * ВАРИАНТ А, ВТОРАЯ ПОЛОВИНА — ПРОПОРЦИИ. Решение владельца 02.09: «автор
 * задаёт одно значение, система выводит пропорции сама».
 *
 * Внутри одной роли тексты сегодня разного кегля (у плашки тизера 0.875 /
 * 0.9375 / 0.75 em, у карточки тарифа 20 / 15 / 12 px). Поставить всем ОДИН
 * авторский кегль значило бы схлопнуть иерархию — у денежного «Выбора тарифа»
 * это прямо убрало бы выделение заметного тарифа, ради которого блок так и
 * нарисован. Поэтому авторское число ставится на ГЛАВНЫЙ текст группы, а
 * соседние считаются от него ТЕМ ЖЕ отношением, что стоит в вёрстке сегодня.
 *
 * Пусто = прежняя строка байт-в-байт: без авторского кегля возвращается
 * накладка БЕЗ `fontSize` (цвет, если задан, идёт как обычно).
 */
export function scaledTextRoleStyle(
  role: TextRoleStyle,
  ratio: number,
): TextRoleStyle {
  if (role.fontSize === undefined) return role;
  return { ...role, fontSize: Math.round(role.fontSize * ratio) };
}

/**
 * ПРИГЛУШЕНИЕ СВОЕЙ ПРОЗРАЧНОСТЬЮ. Там, где приглушённое состояние уже
 * нарисовано прозрачностью (незакрашенная звезда — 0.5), приглушение варианта
 * А обязано взять ИМЕННО ЕЁ, а не общую долю механизма: иначе при заданном
 * цвете вид звёзд поехал бы на ровном месте.
 */
export function mutedTextRoleStyleWith(
  role: TextRoleStyle,
  opacity: number,
): { opacity?: number } {
  return role.color ? { opacity } : {};
}

/** Есть ли что накладывать: пустая накладка = разметка остаётся прежней. */
export function isRoleStyled(role: TextRoleStyle): boolean {
  return role.color !== undefined || role.fontSize !== undefined;
}

/**
 * Накладки блока — ЧЕРЕЗ РЕЕСТР, а не ветками по типу.
 *
 * Требование карточки к способу: «набор полей и их именование одинаковы у всех
 * блоков». Значит и читать значения обязан один код: тип блока даёт префикс,
 * префикс даёт четыре имени поля. Роль, у типа отсутствующая
 * (`SEMANTIC_TEXT_ROLE_OMITTED_ROLES`), возвращается ПУСТОЙ накладкой — то
 * есть нулевой правкой вида, а не выдуманным значением.
 */
export function blockTextRoles(
  block: SemanticTextRoleFields,
  blockType: string,
): BlockTextRoles {
  const prefix = semanticTextRolePrefix(blockType);
  const fields = block as unknown as Record<string, unknown>;
  const read = (role: SemanticTextRole): TextRoleStyle => {
    if (!prefix || !semanticTextRolesOf(blockType).includes(role)) return {};
    return textRoleStyle(
      fields[`${prefix}${role}Color`] as string | undefined,
      fields[`${prefix}${role}FontSize`] as number | undefined,
    );
  };
  return { title: read('Title'), secondary: read('Secondary') };
}

/** Роли блока «Утверждение». Тот же общий механизм, названный по имени. */
export function statementTextRoles(
  block: SemanticTextRoleFields,
): BlockTextRoles {
  return blockTextRoles(block, 'statement_agreement');
}

/** Роли блока «Карточка предпочтения». Тот же общий механизм. */
export function preferenceTextRoles(
  block: SemanticTextRoleFields,
): BlockTextRoles {
  return blockTextRoles(block, 'preference_card');
}

/* ═══════════════════════════════════════════════════════════════════════════
 * ЮНИТ 5 «ДВА ДАУНСЕЛЛА» — СБОРЩИКИ НАКЛАДОК.
 *
 * Собраны здесь, а не в ветке рендера, по одной причине: у «Оффера удержания»
 * карточка предложения рисуется в ДВУХ местах — самим блоком
 * (`portal/DownsellOfferBlock.tsx`) и шагом подтверждения отмены
 * (`portal/CancelSubscriptionButton.tsx` → `CancelDownsellCard`, WEB-1183),
 * который берёт конфигурацию оффера из провайдера портала. Настройка,
 * доехавшая до одной двери из двух, — известный класс дефекта: автор красит
 * оффер, видит его на канвасе, а покупатель на шаге отмены получает прежний
 * вид. Поэтому накладки считаются ОДНОЙ функцией и передаются обеим дверям.
 * ═══════════════════════════════════════════════════════════════════════════ */

/** Накладки «Оффера удержания»: три текста и две заливки. */
export interface DownsellOfferAppearance {
  /** Заголовок оффера. */
  title: TextRoleStyle;
  /** Наполнение: текст, строка новой цены, текст после принятия скидки. */
  secondary: TextRoleStyle;
  /** Надпись кнопки «принять скидку». */
  cta: TextRoleStyle;
  /** Заливка внутри кнопки; пусто = прежний акцент воронки. */
  ctaBackgroundColor?: string;
  /** Заливка внутренней плашки; пусто = плашка без заливки, как сегодня. */
  cardBackgroundColor?: string;
}

/** Накладки «Попапа-даунселла»: четыре текста карточки предложения. */
export interface DownsellPopupTextStyles {
  /** Заголовок предложения (18px). */
  title: TextRoleStyle;
  /** Текст предложения (14px). */
  secondary: TextRoleStyle;
  /** Цена со скидкой (22px — крупнее заголовка намеренно). */
  price: TextRoleStyle;
  /** Надпись кнопки (15px). */
  cta: TextRoleStyle;
}

/**
 * ⚠ СБОРЩИКОВ «СЧИТАЙ ВСЁ ПО БЛОКУ» ЗДЕСЬ НЕТ НАМЕРЕННО. Первая редакция юнита
 * 5 завела их (`downsellOfferAppearance(block)` / `downsellPopupTextStyles(block)`)
 * — и сторож контракта имён (WEB-1500, field-name-contract.spec.ts) покраснел
 * поимённо на восьми полях попапа: имена полей внутри такой функции ветка
 * отрисовки НЕ ЧИТАЕТ, а у блока с реестром парных имён это и есть тот дефект,
 * от которого сторож поставлен (поле теряется между генерацией и рендером).
 *
 * Поэтому накладки собираются В ВЕТКЕ своего типа из двух готовых кирпичей:
 * `blockTextRoles(block, '<тип>')` для ролей (у механизма своё послабление в
 * стороже — оно действует, только если ветка механизм реально зовёт) и
 * `textRoleStyle` / `trimmedColor` для собственных полей, прочитанных под
 * своими именами. Типы накладок объявлены выше и едут в обе двери карточки.
 */
